import React from 'react';


function A8AXIS() {
    return (
        <div>
            <p>PR: 外資コンサルに精通したアドバイザーから転職支援を受けませんか?（無料の新規会員登録）</p>
            <a href="https://px.a8.net/svt/ejp?a8mat=3YYLXT+46MQDE+4G96+626XT" rel="nofollow">
                {/* @ts-ignore */}
                <img border="0" width="234" height="60" alt="" src="https://www24.a8.net/svt/bgt?aid=240120209253&wid=003&eno=01&mid=s00000020769001018000&mc=1" />
            </a>
            {/* @ts-ignore */}
            <img border="0" width="1" height="1" src="https://www13.a8.net/0.gif?a8mat=3YYLXT+46MQDE+4G96+626XT" alt="" />
        </div>
    );
}

export default A8AXIS;
